import axios from "axios";
import WriteToLog from "./WriteToLog";
import getMedicationRequest from "./getMedicationRequest";

/**
 * GetMedicationAdministrationHistory data from EHR
 * @param {*} patID 
 * @param {*} fhir_server 
 * @param {*} access_token 
 * @returns 
 */
async function getMedicationAdministrationHistory(patFHIRID, csn, fhir_server, access_token) {
  const medsAdministered = {};
  var medicationsAdministered = [];
  var interestedOrders = [];
  let value = "";

  var date = new Date();
  date.setHours(date.getHours() - 4);
  const isoStringWithoutMs = date.toISOString().slice(0, 19) + 'Z';
  const windowDate = new Date(Date.parse(isoStringWithoutMs));

  const ehrconfig = await axios.get('ehrconfig.json');
  const _epicWSHeaders = {
    'Authorization': 'Bearer ' + access_token,
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };

  let medicationAdministrationUrl = ehrconfig.data["EHR_GET_MEDICATION_ADMINISTRATION_HISTORY"];
  const EHR_ORDER_MED_NAME = ehrconfig.data["EHR_ORDER_MED_NAME"];
  let getMedicationAdministrationUrl = fhir_server + medicationAdministrationUrl;

  function getPreviousMed(array, index) {
    //console.log("inside function getPreviousMed");
    let newindex = index + 1;
    const prevMed = array[newindex];
    const prevMedAdminsiteredDate = new Date(prevMed.AdministrationInstant);
    //console.log(prevMedAdminsiteredDate);
    //console.log(windowDate);
    if (prevMedAdminsiteredDate >= windowDate) {
      // Check if prevMed action is Stopped and Paused
      if (prevMed.Action.includes("Stopped") || prevMed.Action.includes("Paused")) {
        const otherMedAdministered = getPreviousMed(array, newindex);  
        return otherMedAdministered;
      } else {
        return array[newindex];
      }
    } else {
      return array[newindex];
    }
  }

  /* Step 1: Call MedicationRequest to get Order IDs from EHR */
  const promiseGetOrderIDs = await getMedicationRequest(patFHIRID, fhir_server, access_token); 
  //console.log(promiseGetOrderIDs);

  if (promiseGetOrderIDs.length > 0) {
    try {
      let data = { 
        'PatientID': patFHIRID,
        'PatientIDType': 'FHIR',
        'ContactID': csn,
        'ContactIDType': 'CSN',
        'OrderIDs': promiseGetOrderIDs
      };

      /* Step 2: Call GETMEDICATIONADMINISTRATIONHISTORY */
      const response = await axios.post(getMedicationAdministrationUrl, data, { headers: _epicWSHeaders });
      if (response.data !== undefined) {
        //console.log("getMedicationAdministrationHistory Epic API response: " + JSON.stringify(response.data));
        if (response.data) {
          let ordersArray = response.data.Orders;
          for (var i = 0; i < ordersArray.length; i++) {
            let orderID = ordersArray[i].OrderID.ID;
            let medName = ordersArray[i].Name;
            //console.log("Medication Name: " + medName);
            //console.log("ordersArray[i].IsInfusion should be true: " + ordersArray[i].IsInfusion);
            if ((ordersArray[i].IsInfusion || medName.startsWith(EHR_ORDER_MED_NAME)) && ordersArray[i].MedicationAdministrations !== undefined) {
              //console.log("Medication Name (Infusion or startsWith EPINEPHrine in D5W 10 mcg/mL inj): " + medName);

              let rxnorm;
              var foundItem = promiseGetOrderIDs.find(item => (item.ID === orderID));
              //var foundItem = promiseGetOrderIDs.find(item => (item.ID === orderID) && (item.medName === "ondansetron injection"));
              if (foundItem) {
                rxnorm = foundItem.rxnorm;
              }      
              ordersArray[i].RxCUI = rxnorm;

              let medAdministration = {};
              for (var m = 0; m < ordersArray[i].MedicationAdministrations.length; m++) {
                //console.log(m + " AdministrationInstant: " + ordersArray[i].MedicationAdministrations[m].AdministrationInstant);
                let action = ordersArray[i].MedicationAdministrations[m].Action;
                //console.log(m + " action: " + action);
                if(medAdministration[orderID] === undefined) {
                  const medAdminsiteredDate = new Date(ordersArray[i].MedicationAdministrations[m].AdministrationInstant);
                  //console.log("medAdminsiteredDate: " + medAdminsiteredDate);
                  //console.log("windowDate: " + windowDate);
                  if (medAdminsiteredDate >= windowDate) {
                    // Check if the latest MedicationAdministration action is Stopped and Paused, then get previously administered medicine
                    if (action.includes("Stopped") || action.includes("Paused")) {
                      //console.log(m + " action stopped/paused check: " + action);  
                      const previousMedAdministered = getPreviousMed(ordersArray[i].MedicationAdministrations, m);  
                      medAdministration[orderID] = medName;
                      medAdministration.AdministrationInstant = previousMedAdministered.AdministrationInstant;
                      medicationsAdministered.push(medAdministration);
                    } else {
                      medAdministration[orderID] = medName;
                      medAdministration.AdministrationInstant = ordersArray[i].MedicationAdministrations[m].AdministrationInstant;
                      medicationsAdministered.push(medAdministration);
                    }
                    interestedOrders.push(ordersArray[i]);
                  } else {
                    // TODO: not needed.. check this logic
                    //medAdministration[orderID] = medName;
                    //medAdministration.AdministrationInstant = ordersArray[i].MedicationAdministrations[m].AdministrationInstant;
                    //medicationsAdministered.push(medAdministration);
                  }
                }
              }
            }
          }
          medsAdministered["MedsAdministered"] = medicationsAdministered;
          medsAdministered["Orders"] = interestedOrders;
          //console.log("getMedicationAdministrationHistory result before return: " + JSON.stringify(medicationsAdministered));
          return medsAdministered;
        } else {
          // no response data means no orders were administered.. TODO: check this case
          let entryArray = response.data.entry;
          for (var j = 0; j < entryArray.length; j++) {
            if (entryArray[j].resource !== undefined) {
              let resourceType = entryArray[j].resource.resourceType;
              WriteToLog("getMedicationAdministrationHistory CHECK -- Resource Type: " + resourceType);
              if (resourceType === "OperationOutcome" && entryArray[j].resource.issue !== undefined) {
                let issueArray = entryArray[j].resource.issue;
                if (issueArray.length > 0) {
                  if (entryArray[j].resource.issue[0].diagnostics !== undefined)
                  {
                    value = "Error: " + entryArray[j].resource.issue[0].diagnostics;
                  } else {
                    value = entryArray[j].resource.issue[0].details.text;
                  }
                }
              }
            }
          }
          return value;
        }
      }
    } catch (error) {
      if (error.response) {
        WriteToLog("getMedicationAdministrationHistory error.response: " + JSON.stringify(error.response.data));
        WriteToLog("getMedicationAdministrationHistory error.response: " + JSON.stringify(error.response.status));
      } else if (error.request) {
        WriteToLog("getMedicationAdministrationHistory error.request: " + error.request);
      } else {
        WriteToLog('getMedicationAdministrationHistory Error ', error.message + ' - ' + fhir_server);
      }
      return error.message;
    }
  } // end of if promiseGetOrderIDs
  return "Resource request returns no results.";
}

export default getMedicationAdministrationHistory;
